module.exports = __webpack_public_path__ + "images/category_lp/furniture/store_images/3@2x_5b3d9a8d3606a5b022bf828c82ae4604.png";